import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

const MostViewedArticles = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/1.webp`;
  const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/2.webp`;
  const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/3.webp`;
  const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/4.webp`;
  const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/5.webp`;
  const p6 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/6.webp`;
  const p7 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/7.webp`;
  const p8 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/8.webp`;
  const p9 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/9.webp`;
  const p10 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/10.webp`;
  const p11 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/11.webp`;
  const p12 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/12.webp`;
  const p13 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/13.webp`;
  const p14 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/14.webp`;
  const p15 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/15.webp`;
  const p16 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/16.webp`;
  const p17 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/17.webp`;
  const p18 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/18.webp`;
  const p19 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/19.webp`;
  const p20 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/20.webp`;
  const p21 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/21.webp`;
  const p22 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/22.webp`;
  const p23 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/23.webp`;
  const p24 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/24.webp`;
  const p25 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/25.webp`;
  const p26 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/26.webp`;
  const p27 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/27.webp`;
  const p28 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/28.webp`;
  const p29 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/29.webp`;
  const p30 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/30.webp`;
  const p31 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/31.webp`;
  const p32 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/32.webp`;
  const p33 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/33.webp`;
  const p34 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/34.webp`;
  const p35 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/35.webp`;
  const p36 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/36.webp`;
  const p37 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/37.webp`;
  const p38 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/38.webp`;
  const p39 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/39.webp`;
  const p40 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/40.webp`;
  const p41 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/41.webp`;
  const p42 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/42.webp`;
  const p43 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/43.webp`;
  const p44 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day1/44.webp`;


  const p45 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/1.webp`;
const p46 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/2.webp`;
const p47 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/3.webp`;
const p48 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/4.webp`;
const p49 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/5.webp`;
const p50 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/6.webp`;
const p51 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/7.webp`;
const p52 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/8.webp`;
const p53 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/9.webp`;
const p54 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/10.webp`;
const p55 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/11.webp`;
const p56 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/12.webp`;
const p57 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/13.webp`;
const p58 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/14.webp`;
const p59 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/15.webp`;
const p60 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/16.webp`;
const p61 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/17.webp`;
const p62 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/18.webp`;
const p63 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/19.webp`;
const p64 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/20.webp`;
const p65 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/21.webp`;
const p66 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/22.webp`;
const p67 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/23.webp`;
const p68 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/24.webp`;
const p69 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/25.webp`;
const p70 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/26.webp`;
const p71 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/27.webp`;
const p72 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/28.webp`;
const p73 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/29.webp`;
const p74 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/30.webp`;
const p75 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/31.webp`;
const p76 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/32.webp`;
const p77 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/33.webp`;
const p78 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/34.webp`;
const p79 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/35.webp`;
const p80 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/36.webp`;
const p81 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/37.webp`;
const p82 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/38.webp`;
const p83 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/39.webp`;
const p84 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/40.webp`;
const p85 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/41.webp`;
const p86 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/42.webp`;
const p87 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/43.webp`;
const p88 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/44.webp`;
const p89 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/45.webp`;
const p90 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/46.webp`;
const p91 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/47.webp`;
const p92 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/48.webp`;
const p93 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/49.webp`;
const p94 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/50.webp`;
const p95 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/51.webp`;
const p96 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/52.webp`;
const p97 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/53.webp`;
const p98 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/54.webp`;
const p99 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/55.webp`;
const p100 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/56.webp`;
const p101 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/57.webp`;
const p102 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/58.webp`;
const p103 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/59.webp`;
const p104 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/60.webp`;
const p105 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/61.webp`;
const p106 = `${config.base_image_archive_url}/academic-year-2023-24/home/home-static/our-campus/photo-gallery-2023/Gallery/Day2/62.webp`;


  
  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p5,
      source: p5,
      rows: 1,
      cols: 1,
    },
    {
      src: p6,
      source: p6,
      rows: 1,
      cols: 1,
    },
    {
      src: p7,
      source: p7,
      rows: 1,
      cols: 1,
    },
    {
      src: p8,
      source: p8,
      rows: 1,
      cols: 1,
    },
    {
      src: p9,
      source: p9,
      rows: 1,
      cols: 1,
    },
    {
      src: p10,
      source: p10,
      rows: 1,
      cols: 1,
    }, {
      src: p11,
      source: p11,
      rows: 1,
      cols: 1,
    },
    {
      src: p12,
      source: p12,
      rows: 1,
      cols: 1,
    },
    {
      src: p13,
      source: p13,
      rows: 1,
      cols: 1,
    },
    {
      src: p14,
      source: p14,
      rows: 1,
      cols: 1,
    },
    {
      src: p15,
      source: p15,
      rows: 1,
      cols: 1,
    },
    {
      src: p16,
      source: p16,
      rows: 1,
      cols: 1,
    },
    {
      src: p17,
      source: p17,
      rows: 1,
      cols: 1,
    },
    {
      src: p18,
      source: p18,
      rows: 1,
      cols: 1,
    },
    {
      src: p19,
      source: p19,
      rows: 1,
      cols: 1,
    },
    {
      src: p20,
      source: p20,
      rows: 1,
      cols: 1,
    },
    {
      src: p21,
      source: p21,
      rows: 1,
      cols: 1,
    },
    {
      src: p22,
      source: p22,
      rows: 1,
      cols: 1,
    },
    {
      src: p23,
      source: p23,
      rows: 1,
      cols: 1,
    },
    {
      src: p24,
      source: p24,
      rows: 1,
      cols: 1,
    },
    {
      src: p25,
      source: p25,
      rows: 1,
      cols: 1,
    },
    {
      src: p26,
      source: p26,
      rows: 1,
      cols: 1,
    },
    {
      src: p27,
      source: p27,
      rows: 1,
      cols: 1,
    },
    {
      src: p28,
      source: p28,
      rows: 1,
      cols: 1,
    },
    {
      src: p29,
      source: p29,
      rows: 1,
      cols: 1,
    },
    {
      src: p30,
      source: p30,
      rows: 1,
      cols: 1,
    },
    {
      src: p31,
      source: p31,
      rows: 1,
      cols: 1,
    },
    {
      src: p32,
      source: p32,
      rows: 1,
      cols: 1,
    }, {
      src: p33,
      source: p33,
      rows: 1,
      cols: 1,
    },
    {
      src: p34,
      source: p34,
      rows: 1,
      cols: 1,
    },
    {
      src: p35,
      source: p35,
      rows: 1,
      cols: 1,
    },
    {
      src: p36,
      source: p36,
      rows: 1,
      cols: 1,
    },
    {
      src: p37,
      source: p37,
      rows: 1,
      cols: 1,
    },
    {
      src: p38,
      source: p38,
      rows: 1,
      cols: 1,
    },
    {
      src: p39,
      source: p39,
      rows: 1,
      cols: 1,
    },
    {
      src: p40,
      source: p40,
      rows: 1,
      cols: 1,
    },
    {
      src: p41,
      source: p41,
      rows: 1,
      cols: 1,
    },
    {
      src: p42,
      source: p42,
      rows: 1,
      cols: 1,
    },
    {
      src: p43,
      source: p43,
      rows: 1,
      cols: 1,
    },
    {
      src: p44,
      source: p44,
      rows: 1,
      cols: 1,
    },
   
    {
        src: p45,
        source: p45,
        rows: 1,
        cols: 1,
      },
      {
        src: p46,
        source: p46,
        rows: 1,
        cols: 1,
      },
      {
        src: p47,
        source: p47,
        rows: 1,
        cols: 1,
      },
      {
        src: p48,
        source: p48,
        rows: 1,
        cols: 1,
      },
      {
        src: p49,
        source: p49,
        rows: 1,
        cols: 1,
      },
      {
        src: p50,
        source: p50,
        rows: 1,
        cols: 1,
      },
      {
        src: p51,
        source: p51,
        rows: 1,
        cols: 1,
      },
      {
        src: p52,
        source: p52,
        rows: 1,
        cols: 1,
      },
      {
        src: p53,
        source: p53,
        rows: 1,
        cols: 1,
      },
      {
        src: p54,
        source: p54,
        rows: 1,
        cols: 1,
      },
      {
        src: p55,
        source: p55,
        rows: 1,
        cols: 1,
      },
      {
        src: p56,
        source: p56,
        rows: 1,
        cols: 1,
      },
      {
        src: p57,
        source: p57,
        rows: 1,
        cols: 1,
      },
      {
        src: p58,
        source: p58,
        rows: 1,
        cols: 1,
      },
      {
        src: p59,
        source: p59,
        rows: 1,
        cols: 1,
      },
      {
        src: p60,
        source: p60,
        rows: 1,
        cols: 1,
      },
      {
        src: p61,
        source: p61,
        rows: 1,
        cols: 1,
      },
      {
        src: p62,
        source: p62,
        rows: 1,
        cols: 1,
      },
      {
        src: p63,
        source: p63,
        rows: 1,
        cols: 1,
      },
      {
        src: p64,
        source: p64,
        rows: 1,
        cols: 1,
      },
      {
        src: p65,
        source: p65,
        rows: 1,
        cols: 1,
      },
      {
        src: p66,
        source: p66,
        rows: 1,
        cols: 1,
      },
      {
        src: p67,
        source: p67,
        rows: 1,
        cols: 1,
      },

      {
        src: p68,
        source: p68,
        rows: 1,
        cols: 1,
      },

      {
        src: p69,
        source: p69,
        rows: 1,
        cols: 1,
      },

      {
        src: p70,
        source: p70,
        rows: 1,
        cols: 1,
      },
      {
        src: p71,
        source: p71,
        rows: 1,
        cols: 1,
      },

      {
        src: p72,
        source: p72,
        rows: 1,
        cols: 1,
      },

      {
        src: p73,
        source: p73,
        rows: 1,
        cols: 1,
      },

      {
        src: p74,
        source: p74,
        rows: 1,
        cols: 1,
      },

      {
        src: p75,
        source: p75,
        rows: 1,
        cols: 1,
      },

      {
        src: p76,
        source: p76,
        rows: 1,
        cols: 1,
      },

      {
        src: p77,
        source: p77,
        rows: 1,
        cols: 1,
      },

      {
        src: p78,
        source: p78,
        rows: 1,
        cols: 1,
      },

      {
        src: p79,
        source: p79,
        rows: 1,
        cols: 1,
      },

      {
        src: p80,
        source: p80,
        rows: 1,
        cols: 1,
      },

      {
        src: p81,
        source: p81,
        rows: 1,
        cols: 1,
      },

      {
        src: p82,
        source: p82,
        rows: 1,
        cols: 1,
      },

      {
        src: p83,
        source: p83,
        rows: 1,
        cols: 1,
      },

      {
        src: p84,
        source: p84,
        rows: 1,
        cols: 1,
      },

      {
        src: p85,
        source: p85,
        rows: 1,
        cols: 1,
      },

      {
        src: p86,
        source: p86,
        rows: 1,
        cols: 1,
      },

      {
        src: p87,
        source: p87,
        rows: 1,
        cols: 1,
      },

      {
        src: p88,
        source: p88,
        rows: 1,
        cols: 1,
      },

      {
        src: p89,
        source: p89,
        rows: 1,
        cols: 1,
      },

      {
        src: p90,
        source: p90,
        rows: 1,
        cols: 1,
      },

      {
        src: p91,
        source: p91,
        rows: 1,
        cols: 1,
      },

      {
        src: p92,
        source: p92,
        rows: 1,
        cols: 1,
      },

      {
        src: p93,
        source: p93,
        rows: 1,
        cols: 1,
      },

      {
        src: p94,
        source: p94,
        rows: 1,
        cols: 1,
      },

      {
        src: p95,
        source: p95,
        rows: 1,
        cols: 1,
      },

      {
        src: p96,
        source: p96,
        rows: 1,
        cols: 1,
      },

      {
        src: p97,
        source: p97,
        rows: 1,
        cols: 1,
      },

      {
        src: p98,
        source: p98,
        rows: 1,
        cols: 1,
      },

      {
        src: p99,
        source: p99,
        rows: 1,
        cols: 1,
      },

      {
        src: p100,
        source: p100,
        rows: 1,
        cols: 1,
      },

      {
        src: p101,
        source: p101,
        rows: 1,
        cols: 1,
      },

      {
        src: p102,
        source: p102,
        rows: 1,
        cols: 1,
      },

      {
        src: p103,
        source: p103,
        rows: 1,
        cols: 1,
      },

      {
        src: p104,
        source: p104,
        rows: 1,
        cols: 1,
      },

      {
        src: p105,
        source: p105,
        rows: 1,
        cols: 1,
      },

      {
        src: p106,
        source: p106,
        rows: 1,
        cols: 1,
      },


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Box>
      <Box display={'flex'} justifyContent={'flex-end'} marginBottom={2}>
        {/* <Button
          color="primary"
          size="large"
          endIcon={
            <svg
              width={16}
              height={16}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          }
          onClick={() => openLightbox(0)}
        >
          Open the gallery
        </Button> */}
      </Box>
      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
  );
};

export default MostViewedArticles;